export const HOME_SCREEN = {
  MESSAGES_SENT: 'Messages sent',
  UNIQUE_RECIPIENTS: 'Unique recipients',
  CONFIRMED_DELIVERIES: 'Confirmed deliveries',
  TOTAL_REVENUE: 'Total revenue',
  CURRENT_AUDIENCE: 'Current audience',
  CREDIT_BALANCE: 'Credit Balance',
  CREATE_CAMPAIGN: 'Create campaign',
  SCHEDULED_CAMPAIGNS: 'Scheduled campaigns',
  CAMPAIGN_ANALYTICS: 'Campaign analytics',
};
